<template>
  <div>
    <ChartInteraction
      monthGet="/api/dashboard/getDashboardMonthlyAdmin"
      yearGet="/api/dashboard/GetDashboardYearAdmin"
      dayGet="/api/dashboard/GetDashboardDayAdmin"
      :isAdmin="true"
    ></ChartInteraction>

    <b-card no-body>
      <transaction-search-results
        :query="getTransactionQuery()"
        transactionUrl="/api/transaction/transactionsAdmin"
        :supressPatientName="true"
        :showCompany="true"
      ></transaction-search-results>
    </b-card>
  </div>
</template>

<script>
import Companies from "@/views/Components/Admin/Companies";
import ChartInteraction from "@/views/Components/Dashboard/ChartInteraction";
import TransactionSearchResults from "@/views/Components/Transactions/SearchResults";

export default {
  components: {
    ChartInteraction,
    Companies,
    TransactionSearchResults,
  },
  methods: {
    getTransactionQuery() {
      var self = this;
      return {
        statuses: ["APPROVED", "DECLINED"],
        currentPage: 1,
        modules: [
          "TEXTTOPAY",
          "PAYMENTPLAN",
          "MEMBERSHIP",
          "TERMINAL",
          "PAYMENTPAGE",
          "VIRTUALTERMINAL",
        ],
        sortOption: "Date:descending",
      };
    },
  },
};
</script>
